/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2025-04-15T17:15:33.307
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listReportMonthRentHouseBig,
	listReportMonthRentHouseBigInit,
	listReportMonthRentHouseBigByAuthorizations,
	deleteReportMonthRentHouseBig
	
} from '@api/report/ReportMonthRentHouseBig';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listReportMonthRentHouseBig({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportMonthRentHouseBig(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportMonthRentHouseBigByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportMonthRentHouseBigByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportMonthRentHouseBigInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportMonthRentHouseBigInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteReportMonthRentHouseBig({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportMonthRentHouseBig({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
